module.exports = __webpack_public_path__ + "static/media/app7.79b5d53e.png";